import {toast} from "react-toastify";
import {SocketApiAckStatus, SocketApiTxStatus} from "proto_socket_typescript";

export abstract class ErrorUtils {
  static async handleApiError(message: string, e: any) {
    if (e instanceof Response) {
      toast.error(`${message} (${e.status})`);
    } else {
      toast.error(`${message} (${e})`);
    }
  }

  static fromFetch(e: any) {
    if (e instanceof SocketApiTxStatus && e.status === SocketApiAckStatus.success) {
      return true;
    }
    toast.error(ErrorUtils.toString(e));
    return false;
  }

  static toString(e: any) {
    if (e instanceof SocketApiTxStatus) {
      return e.errorMessage;
    } else if (e.message) {
      return e.message;
    } else {
      return e.toString();
    }
  }
}
